jQuery(document).foundation();

(function($) {
    $(document).ready(function() {
        $('ul.thumbnails a').on('click', function(e) {
            e.preventDefault();
            $('.video iframe').attr('src', $(this).attr('href'));
        });
    });
})(jQuery);